export const endpoints = {
  appleFairPlayCertificate: (host: string) =>
    `${host}/security/drm/apple/fairplay/fairplay2021v1.cer`,
};
